import React, { Fragment } from 'react';
import {
  Box,
  Text,
  Badge,
  IconChevron,
  Columns,
  Column,
} from 'braid-design-system';

import * as styles from './User.css';
import { Tags } from '../../../../../../types';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export interface UserProps {
  userFirstName: string | null;
  advertiserName: string | null;
  isConnectedTalentSearchUser: boolean;
  isOnTrial: boolean | null;
  isToggled: boolean;
  onClick: () => void;
}

function User({
  userFirstName,
  advertiserName,
  isConnectedTalentSearchUser,
  isOnTrial,
  isToggled,
  onClick,
}: UserProps) {
  const { t } = useTranslations(translations);

  const renderBadges = () => (
    <Fragment>
      {(isOnTrial || isConnectedTalentSearchUser) && (
        <Column width="content">
          {isOnTrial && (
            <Badge tone="promote" weight="strong">
              {t('TRIAL')}
            </Badge>
          )}
          {isConnectedTalentSearchUser && (
            <Badge tone="promote" weight="strong">
              TSC
            </Badge>
          )}
        </Column>
      )}
    </Fragment>
  );

  return (
    <button className={`${styles.container}`} onClick={onClick}>
      <Box data-cy={Tags.Data.AccountToggle} background="brand">
        <Columns alignY="center" space="xsmall">
          <Column>
            <Text weight="strong" truncate>
              {userFirstName || advertiserName || 'Menu'}
            </Text>
          </Column>
          {renderBadges()}
          <Column width="content">
            <IconChevron direction={isToggled ? 'up' : 'down'} />
          </Column>
        </Columns>
      </Box>
    </button>
  );
}

export default User;
